import React from 'react';

function featuredImage(props) {
  const {
    image, 
    imageSize,
    srcset
  } = props;

  let imgTag = '';
  let srcsetData = '';

  if (srcset && srcset[imageSize] && srcset[imageSize].srcset) {
    srcsetData = srcset[imageSize].srcset;
  }

  if (image && image[imageSize]) {
    imgTag = <img src={image[imageSize].src} srcSet={srcsetData} alt={image[imageSize].alt}></img>;
  }

  return imgTag;
}

export default featuredImage;